import {type ClassValue, clsx} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number of cents into a currency string
 * @param cents The number of cents
 */
export function formatCents(cents: number) {
  return (cents / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  })
}

/**
 * Calculate the surcharge amount
 *
 * @param cost The total.
 * @param surcharge The surcharge percentage.
 * @returns The surcharge amount.
 */
export function calculateSurcharge(cost: number, surcharge: number) {
  if (cost === 0 || surcharge === 0) {
    return 0
  }

  // Convert the surcharge to a decimal
  const surchargeDecimal = surcharge / 100.00

  // Calculate total amount including surcharge
  return Math.ceil(cost / (1 - surchargeDecimal)) - cost;
}